import { useState, useEffect } from "react";

export default function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie-consent");
    if (!consent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem("cookie-consent", "accepted");
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-background-50 border-t border-background-200/70 shadow-lg p-4 md:p-6">
      <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <div className="text-sm text-foreground-600">
          <p className="font-medium text-foreground-800 mb-1">Datenschutzhinweis</p>
          <p>
            Diese Webseite verwendet nur technisch notwendige Cookies. Wir setzen keine Tracking-Tools oder Analyse-Dienste ein.
          </p>
        </div>
        <button
          onClick={handleAccept}
          className="shrink-0 px-6 py-2.5 bg-primary-500 text-background-50 rounded-md text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
        >
          Verstanden
        </button>
      </div>
    </div>
  );
}